import React from "react";
import FormDataProvider from "integrations/contexts/FormDataProvider";
import { toGenericInputCreateRequest } from "./common/formDataAdapter";
import CloudTrail from "./CloudTrail";
import INITIAL_FORMDATA from "./_initialFormData";
import { SidebarProvider } from "../context/Sidebar";
import { StepsProvider } from "../context/Steps";
import { AdvancedOptionsProvider } from "../context/AdvancedOptions";
const EmbeddedCloudTrailApp = ({ onSubmit = void 0 }) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }
    onSubmit(toGenericInputCreateRequest(formData));
  };
  return /* @__PURE__ */ React.createElement(StepsProvider, null, /* @__PURE__ */ React.createElement(FormDataProvider, { initialFormData: INITIAL_FORMDATA }, /* @__PURE__ */ React.createElement(SidebarProvider, null, /* @__PURE__ */ React.createElement(AdvancedOptionsProvider, null, /* @__PURE__ */ React.createElement(CloudTrail, { onSubmit: handleSubmit, externalInputSubmit: typeof onSubmit === "function" })))));
};
export default EmbeddedCloudTrailApp;
